import React, { useState } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Close from "@mui/icons-material/Close";
import {
  useGetLatestNotificationsQuery,
  useGetNotificationCountQuery,
  useGetNotificationsQuery,
} from "../../api/notificationApi";
import CreateNotification from "./CreateNotification";
import { Add } from "@mui/icons-material";
import Notification from "./Notification";
import {
  EventAvailable as EventAvailableIcon,
  HowToReg as HowToRegIcon,
  Assignment as AssignmentIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  NotificationsActive as NotificationsActiveIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { getToken } from "../../services/Token";

const NotificationsOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  useGetNotificationsQuery({}, { skip: !isOpen,refetchOnMountOrArgChange: true });
  const role = getToken("roles");
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const { allNotifications, latestNotifications, count } = useSelector(
    (state) => state.notification
  );
  useGetNotificationCountQuery(
    {},
    {
      pollingInterval: 600000,
    }
  );
  useGetLatestNotificationsQuery(
    {},
    { skip: activeFilter === "all", refetchOnMountOrArgChange: true }
  );
  const { isAnnouncementOpen } = useSelector((state) => state.notification);

  const notifications = allNotifications?.data;
  const latestData = latestNotifications?.data;

  const getNotificationIcon = (type) => {
    switch (type) {
      case "LEAVE":
        return <EventAvailableIcon className="w-5 h-5 text-blue-500" />;
      case "ATTENDANCE":
        return <HowToRegIcon className="w-5 h-5 text-green-500" />;
      case "TIMESHEET":
        return <AssignmentIcon className="w-5 h-5 text-yellow-500" />;
      case "PAYROLL":
        return <AccountBalanceWalletIcon className="w-5 h-5 text-purple-500" />;
      default:
        return <NotificationsActiveIcon className="w-5 h-5 text-gray-500" />;
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "LEAVE":
        return "bg-blue-50 text-blue-700 border-blue-200";
      case "ATTENDANCE":
        return "bg-green-50 text-green-700 border-green-200";
      case "TIMESHEET":
        return "bg-yellow-50 text-yellow-700 border-yellow-200";
      case "PAYROLL":
        return "bg-purple-50 text-purple-700 border-purple-200";
      default:
        return "bg-gray-50 text-gray-700 border-gray-200";
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          setActiveFilter("all");
          setIsOpen(true)
        }}
        className="relative p-3 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-200 border border-gray-100 hover:bg-gray-50"
      >
        <NotificationsIcon className="w-6 h-6 text-gray-600" />
        {count?.data > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
            {count?.data}
          </span>
        )}
      </button>

      {isOpen && (
        <button
          className="fixed inset-0 bg-white bg-opacity-60 z-[999] transition-opacity duration-300 "
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`fixed ${
          isAnnouncementOpen ? "top-14" : "top-0"
        } right-0 h-full w-[400px] bg-white shadow-2xl z-[9999] transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">
                Notifications{" "}
                {/* <span className="text-orange-600">({count?.data})</span> */}
              </h2>
              {/* <p className="text-sm text-gray-500 mt-1">
                {notifications?.length > 0
                  ? `${notifications?.length} Notifications`
                  : "All caught up!"}
              </p> */}
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 rounded-full hover:bg-white hover:shadow-md transition-all duration-200"
            >
              <Close className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          <div className="flex border-b border-gray-100 bg-gray-50">
            <button
              onClick={() => setActiveFilter("all")}
              className={`flex-1 py-3 px-4 text-sm font-medium transition-all duration-200 ${
                activeFilter === "all"
                  ? "text-blue-600 border-b-2 border-blue-600 bg-white"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
              }`}
            >
              All
              {/* ({notifications?.length}) */}
            </button>
            <button
              onClick={() => setActiveFilter("unread")}
              className={`flex-1 py-3 px-4 text-sm font-medium transition-all duration-200 relative ${
                activeFilter === "unread"
                  ? "text-blue-600 border-b-2 border-blue-600 bg-white"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
              }`}
            >
              Unread
              <span className="text-orange-600 ml-2">({count?.data})</span>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto pb-[140px] notificationScroll">
            {notifications?.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                <NotificationsIcon className="w-12 h-12 text-gray-300 mb-4" />
                <p className="text-lg font-medium mb-2">No notifications</p>
                <p className="text-sm text-center px-8">
                  {activeFilter === "unread"
                    ? "You're all caught up! No unread notifications."
                    : "You don't have any notifications yet."}
                </p>
              </div>
            ) : (
              <div className="divide-y divide-gray-100">
                <Notification
                  getTypeColor={getTypeColor}
                  getNotificationIcon={getNotificationIcon}
                  data={activeFilter === "unread" ? latestData : notifications}
                />
              </div>
            )}
          </div>
          {role === "ADMIN" && (
            <div
              className={`p-4 border-t border-gray-100 bg-gray-50 w-full absolute ${
                isAnnouncementOpen ? " bottom-[55px]" : "bottom-0"
              }`}
            >
              <button
                onClick={() => setShowCreateDialog(true)}
                className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
              >
                <Add className="w-5 h-5" />
                <span>Create Notification</span>
              </button>
            </div>
          )}
        </div>
      </div>
      <CreateNotification
        setShowCreateDialog={setShowCreateDialog}
        showCreateDialog={showCreateDialog}
      />
    </div>
  );
};

export default NotificationsOverlay;
